import React, { FC, useEffect, useReducer } from "react";
import { AuthReducer } from "../reducers/AuthReducer";
import { useAuth } from "../hooks/useAuth";
import { UserType } from "../types/UserType";
import { UserModel } from "../models/UserModel";
import { AuthType } from "../types/AuthType";
import { useNavigate } from "react-router-dom";
import LogRocket from "logrocket";
import mixpanel from "mixpanel-browser";
import { BusinessType } from "../types/BusinessType";

const DefaultAuthData: AuthType = {
    isAuth: false,
    setIsAuth: (isAuth: boolean) => { },
    termsAgreed: false,
    setTermsAgreed: (termsAgreed: boolean) => { },
    user: undefined,
    setUser: (user: UserType) => { },
    loading: false,
    businesses: undefined,
    setBusinesses: (businesses) => { },
    getBusinessById: (businesses: BusinessType[] | undefined, id: number) => undefined
};
const AuthContext = React.createContext(DefaultAuthData);
const AuthContextProvider: FC = ({ children }) => {
    const { isAuth, deleteToken } = useAuth();
    const setIsAuth = (isAuth: boolean) => {
        dispatch({ type: 'setIsAuth', isAuth: isAuth });
    }

    const setTermsAgreed = (termsAgreed: boolean | undefined) => {
        termsAgreed = (termsAgreed === undefined) ? false : termsAgreed;
        dispatch({ type: 'setTermsAgreed', termsAgreed: termsAgreed });
    }

    const setUser = (user: UserType) => {
        try {
            LogRocket.identify(`${user.id}`, {
                name: user.name,
                email: user.email
            });
        } catch (e) { }

        try {
            mixpanel.identify(`${user.id}`);
            mixpanel.people.set({
                "$email": user.email,
                "$name": user.name,
                "Total Nascidos Vivos": user.borns_alive_count,
                "Total Pareamentos": user.pairings_count,
                "Total Doadoras": user.donors_count,
                "Total Receptoras": user.receivers_count,
                "business_id": user.business_id,
                "Clínica": `${user.business_id} - ${user.business?.name || ""}`,
            });
        } catch (e) { }

        dispatch({ type: 'setUser', user: user });
        setBusinesses(user.businesses || []);
    }

    const setBusinesses = (businesses: any) => {
        dispatch({ type: 'setBusinesses', businesses: businesses });
    }

    const getBusinessById = (businesses: BusinessType[] | undefined, id: number) => {
        if (businesses) {
            return businesses.find((b: any) => b.id === id);
        } else {
            return undefined;
        }

    }

    const loadUser = () => {
        dispatch({ type: 'setLoading', loading: true });
        UserModel().get("self").then((loadedUser) => {
            dispatch({ type: 'setLoading', loading: false });
            if (typeof loadedUser !== "boolean") {
                setUser(loadedUser);
                setTermsAgreed(loadedUser.terms_agreed);
            } else {
                if (window.confirm("Houve um erro! Deseja tentar novamente?")) {
                    window.location.reload();
                } else {
                    setIsAuth(false);
                    deleteToken();
                    window.location.reload();
                }
            }
        });
    }

    useEffect(() => {
        if (data.isAuth) {
            loadUser();
        }
    }, [])

    const [data, dispatch] = useReducer(AuthReducer, {
        ...DefaultAuthData,
        setIsAuth: setIsAuth,
        isAuth: isAuth(),
        setUser: setUser,
        setTermsAgreed: setTermsAgreed,
        setBusinesses: setBusinesses,
        getBusinessById: getBusinessById
    });
    return (<AuthContext.Provider value={data}>{children}</AuthContext.Provider>);
}

export { AuthContextProvider, AuthContext }